import React, { useEffect, useState } from 'react';
import { Modal, Button, Table, Card } from 'react-bootstrap';
import * as api from '~/Services/Service';
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast } from 'react-toastify';
import Loading from '~/Components/Loading';
import moment from 'moment';
import { FaUser, FaBuilding, FaCalendarAlt } from 'react-icons/fa';
import '../TagAtendimento.css';

function ModalProspectoVinculoTag({ show, onHide, infos, modoMobile }) {
  const [loading, setLoading] = useState(false);
  const [vinculos, setVinculos] = useState([]);
  const [descricaoTag] = useState(infos.descricao_tag);
  const [codigoTag] = useState(infos.codigo_tag);

  useEffect(() => {
    const buscarVinculosTag = async codigo_tag => {
      setLoading(true);
      try {
        const response = await api.BuscarVinculosTag(codigo_tag);

        if (response && response.length > 0) {
          setVinculos(
            response
              .filter(item => item.prospecto && item.prospecto.trim() !== '')
              .slice()
              .sort((a, b) => {
                if (a.prospecto < b.prospecto) return -1;
                if (a.prospecto > b.prospecto) return 1;
                return 0;
              })
          );
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };

    buscarVinculosTag(codigoTag);
  }, [codigoTag]);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Prospectos vinculados à tag: <strong>{descricaoTag}</strong>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && (
          <div className="loading-container">
            <Loading />
          </div>
        )}

        {!loading && vinculos.length === 0 && (
          <div className="empty-state">Nenhum vínculo encontrado.</div>
        )}

        {!modoMobile && !loading && vinculos.length > 0 && (
          <div className="table-container">
            <table className="table table-custom">
              <thead>
                <tr>
                  <th>Nome do Prospecto</th>
                  <th>Nome do Empreendimento</th>
                  <th>Data do Vínculo</th>
                </tr>
              </thead>
              <tbody>
                {console.log('vinc', vinculos)}
                {vinculos.map((item, idx) => (
                  <tr key={idx}>
                    <td>
                      <span style={{ fontWeight: '500', color: '#1e293b' }}>
                        {item.prospecto}
                      </span>
                    </td>
                    <td>
                      <span style={{ color: '#475569' }}>
                        {item.empreendimento ||
                          'Não possui vínculo com empreendimento'}
                      </span>
                    </td>
                    <td>
                      <span style={{ fontWeight: '500', color: '#64748b' }}>
                        {moment(item.data_vinculo).format('DD/MM/YYYY')}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {modoMobile && !loading && vinculos.length > 0 && (
          <>
            {vinculos.map((item, idx) => (
              <div key={idx} className="mobile-card">
                <div className="mobile-card-body">
                  <div className="mobile-card-title d-flex align-items-center mb-2">
                    <FaUser
                      className="me-2"
                      style={{ color: 'var(--primary-light-01)' }}
                    />
                    {item.prospecto}
                  </div>

                  <div className="mobile-card-subtitle d-flex align-items-center mb-2">
                    <FaBuilding
                      className="me-2"
                      style={{ color: 'var(--success)' }}
                    />
                    {item.empreendimento ||
                      'Não possui vínculo com empreendimento'}
                  </div>

                  <div className="mobile-card-subtitle d-flex align-items-center">
                    <FaCalendarAlt
                      className="me-2"
                      style={{ color: 'var(--atencao)' }}
                    />
                    Data do vínculo:{' '}
                    {moment(item.data_vinculo).format('DD/MM/YYYY')}
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
          className="btn-custom btn-outline-custom"
        >
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalProspectoVinculoTag;
